import React, { useEffect, useState } from 'react';

import { Spinner } from 'components/Spinner/Spinner';
import ResizableRows from 'components/ResizableRows/ResizableRows';
import FreecodeTabSelector from 'components/FreecodePage/FreecodeTabSelector/FreecodeTabSelector';
import { useFreecodeContextData } from 'hooks/useContext';
import { identifiers, tabLabels } from './FreecodeLayoutConstants';

const topContainerOptions = [
  identifiers.summary,
  identifiers.description,
  identifiers.flow,
  identifiers.course,
  identifiers.api,
  identifiers.implementation,
  identifiers.solution,
  identifiers.result,
  identifiers.discussion,
  identifiers.apiSettings,
  identifiers.graphicsSettings,
  identifiers.settings,
  identifiers.preview,
  identifiers.enableSkeletonEditing,
];

const resultColumnOptions = [identifiers.canvas, identifiers.console];

/**
 * Given a map with component display them in a single column
 */
export default function FreecodeLayoutSmall({ componentMap }) {
  const [mainItems, setMainItems] = useState([]);
  const [resultItems, setResultItems] = useState([]);
  const [canvasPercentage, setCanvasPercentage] = useState(25);

  const { testImpl } = useFreecodeContextData();

  useEffect(() => {
    let newResultItems = [];
    for (const keyName of resultColumnOptions) {
      if (componentMap[keyName]) newResultItems.push(keyName);
    }

    let newMainItems = [];
    for (const keyName of topContainerOptions) {
      if (componentMap[keyName]) {
        newMainItems.push(keyName);
      } else if (keyName === identifiers.result && newResultItems.length) {
        newMainItems.push(keyName);
      }
    }

    setMainItems(newMainItems);
    setResultItems(newResultItems);
  }, [componentMap]);

  useEffect(() => {
    if (!resultItems.includes(identifiers.canvas)) return;
    // Offset header height
    let columnHeight = window.innerHeight - 95;
    let columnWidth = window.innerWidth;

    let widthUnit = columnWidth / testImpl.configCanvas.width;
    // offset canvas header, footer, and draggable gutter size
    let desiredCanvasHeight = widthUnit * testImpl.configCanvas.height + 78;

    let desiredHeightPercentage = (100 * desiredCanvasHeight) / columnHeight;

    setCanvasPercentage(Math.min(desiredHeightPercentage, 75));
    window.dispatchEvent(new Event('resize'));
  }, [testImpl.configCanvas, resultItems]);

  const renderResultColumn = () => {
    if (!resultItems.length) return <Spinner key="rightSpinner" />;
    if (resultItems.length === 1) return componentMap[resultItems[0]];
    return (
      <ResizableRows key="ResultColumn" sizes={[canvasPercentage, 100 - canvasPercentage]}>
        {componentMap[resultItems[0]]}
        {componentMap[resultItems[1]]}
      </ResizableRows>
    );
  };

  return !mainItems.length ? (
    <Spinner key="mainSpinner" />
  ) : (
    <FreecodeTabSelector
      key="MainTabSelector"
      items={mainItems.map((KeyName) => ({
        label: tabLabels[KeyName]?.label,
        icon: tabLabels[KeyName]?.icon,
        tabId: tabLabels[KeyName]?.tabId,
        component: KeyName === identifiers.result ? renderResultColumn() : componentMap[KeyName],
      }))}
    />
  );
}
